module.exports = __webpack_public_path__ + "static/media/googleplaybadge_zh.13359ec8.png";